import measurementImageUrl from "@/assets/measurement.svg"
import HeroImage from "@/components/HeroImage"
import Page from "@/components/Page"
import { Button } from "@/components/chadcn/Button"
import { ROUTES } from "@/routes"
import { useNavigate } from "react-router"

const DeviceSetupCompletedPage = () => {
  const navigate = useNavigate()

  return (
    <Page showAppbar={false}>
      <HeroImage src={measurementImageUrl} />
      <div className="flex flex-col gap-6">
        <h1 className="text-center text-h2">Device linked!</h1>
        <p className="text-center text-base text-primary-contrast/70">
          Your device has been successfully linked to your account. You can now start using it to
          track your readings.
        </p>
        <Button
          type="button"
          className="w-full py-2 text-base"
          onClick={() => navigate(ROUTES.DASHBOARD, { replace: true })}
        >
          Go to dashboard
        </Button>
      </div>
    </Page>
  )
}

export default DeviceSetupCompletedPage
